module.exports = __webpack_public_path__ + "static/media/member_6.dd80af43.png";